function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#2F3947",
  fillRule: "evenodd"
}, React.createElement("rect", {
  width: 14,
  height: 1.5,
  rx: 0.75
}), React.createElement("rect", {
  y: 5.25,
  width: 14,
  height: 1.5,
  rx: 0.75
}), React.createElement("rect", {
  y: 10.5,
  width: 14,
  height: 1.5,
  rx: 0.75
}));

var SvgHamburger = function SvgHamburger(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='14px' height='12px' viewBox='0 0 14 12' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg transform='translate(-36.000000, -22.000000)' fill='%232F3947'%3E %3Cg%3E %3Cg transform='translate(36.000000, 22.000000)'%3E %3Crect x='0' y='0' width='14' height='1.5' rx='0.75'%3E%3C/rect%3E %3Crect x='0' y='5.25' width='14' height='1.5' rx='0.75'%3E%3C/rect%3E %3Crect x='0' y='10.5' width='14' height='1.5' rx='0.75'%3E%3C/rect%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgHamburger as ReactComponent };